/*global myDataLayer, myModal, inputDirectionChange */
let whichFormIsSubmitted = null;
let buttonName = null;
var affiliate = {
    isTermsCheckboxChecked: false,
    init: function() {
        affiliate.action();
        affiliate.validate();
    },
    action: function() {
        const affFaqAnswer = '.aff-faq-answer';
        const affFaqChevronUp = '.aff-faq-chevron-up';
        const chevronsCombined = '.aff-faq-chevron-up, .aff-faq-chevron-down';
        $(window).scroll(function() {
            var sticky = $('.header, body'),
                scroll = $(window).scrollTop(),
                promo = $('.promo-banner'),

                startFrom = (promo.length > 0 ? promo.outerHeight() : 0);

            if (scroll > startFrom) {
                sticky.addClass('fixed');
            } else {
                sticky.removeClass('fixed');
            }

            affiliate.updateHeaderV2();
        });

        $('.aff-scroll-to-form').on('click', function(e) {
            e.preventDefault();
            affiliate.scrollTo($('#aff-section-form'), 800);
        });
        $('.aff-scroll-to-next').on('click', function(e) {
            e.preventDefault();
            affiliate.scrollTo($('.aff-page:first'), 400);
        });

        $('#affSignInBtn').on('click', function() {
            $('#affiliateFormError').hide();
            let checkbox = $('#tcAgree');
            let checkboxLabel = $('label[for="' + checkbox.attr('id') + '"]');
            whichFormIsSubmitted = 'affiliateForm';
            buttonName = 'affSignInBtn';
            affiliate.updateCheckboxStatus(checkbox, checkboxLabel);
            affiliate.validate();
        });
        $('#affSignInBtnUpperForm').on('click', function() {
            $('#affiliateUpperFormError').hide();
            let upperFormCheckbox = $('#tcAgreeUpperForm');
            let upperFormCheckboxLabel = $('label[for="' + upperFormCheckbox.attr('id') + '"]');
            whichFormIsSubmitted = 'affiliateUpperForm';
            buttonName = 'affSignInBtnUpperForm';
            affiliate.updateCheckboxStatus(upperFormCheckbox, upperFormCheckboxLabel);
            affiliate.validate();
        });

        $('#tcAgree').on('click', function() {
            let checkbox = $(this);
            let checkboxLabel = $('label[for="' + $(this).attr('id') + '"]');
            affiliate.updateCheckboxStatus(checkbox, checkboxLabel);
        });

        $('#tcAgreeUpperForm').on('click', function() {
            let checkbox = $(this);
            let checkboxLabel = $('label[for="' + $(this).attr('id') + '"]');
            affiliate.updateCheckboxStatus(checkbox, checkboxLabel);
        });

        $(affFaqAnswer).hide();
        $(affFaqChevronUp).hide();
        $(affFaqAnswer).find(affFaqChevronUp).toggle();
        $('.aff-faq-question').click(function() {
            $(this).find(affFaqAnswer).slideToggle();
            // if ($(this).is(':odd') || $(this).is(':first-child')) {
            //     // $(this).next().find(affFaqAnswer).slideToggle();
            //     // $(this).next().find(chevronsCombined).toggle();
            //     $(this).find(chevronsCombined).toggle();
            // } else {
                // $(this).prev().find(affFaqAnswer).slideToggle();
                // $(this).prev().find(chevronsCombined).toggle();
                $(this).find(chevronsCombined).toggle();
            // }
        });

        $('input').each(function() {
            inputDirectionChange.onChangeAction(this);
        });
    },
    updateCheckboxStatus: function(checkbox, label) {
        if (checkbox.is(':checked')) {
            affiliate.isTermsCheckboxChecked = true;
            label.removeClass('error');
        } else {
            affiliate.isTermsCheckboxChecked = false;
            label.addClass('error');
        }
    },
    scrollTo: function(target, timeout) {
        $('html, body').animate({
            scrollTop: target.offset().top - $('.header').height()
        }, timeout);
    },
    validate: function() {
        $.validator.addMethod('validate_username', function(email) {
            var usernameRegEx = /^([a-zA-Z0-9_-]+)$/;
            return usernameRegEx.test(email) === true;
        });

        let btn = $('#' + buttonName);

        $('#' + whichFormIsSubmitted).validate({
            errorClass: 'error',
            focusInvalid: false,
            errorElement: 'div',
            rules: {
                affEmail: {
                    validate_email: true
                },
                affUsername: {
                    validate_username: true
                }
            },
            errorPlacement: function(error, element) {
                error.appendTo( element.next());
            },
            invalidHandler: function() {
                btn.removeClass('loading');
            },
            submitHandler: function() {
                if (affiliate.isTermsCheckboxChecked === true) {
                    btn.attr('disabled', true);
                    $.postJSON(_d.url.affiliate.signup,
                        $('#' + whichFormIsSubmitted).serialize(), function(response) {
                            btn.removeClass('loading').attr('disabled', false);
                            if (!response.error) {
                                myDataLayer.send('post-affiliate');
                                myModal.staticModal('thankYouAffiliateModal',
                                    { msg: response.message });
                            } else if (response.errorType === 'message') {
                                $.each(response.message, function(id, msg) {
                                    $('#' + id + 'Error', '#' + whichFormIsSubmitted).
                                        append('<div id="' + id +
                                            '-error" class="error">' + msg +
                                            '</div>');
                                    $('#' + id, '#' + whichFormIsSubmitted).addClass('error');
                                });
                            } else {
                                $('#' + whichFormIsSubmitted + 'Error').
                                    html(response.message).
                                    show();
                            }
                        });
                } else {
                    btn.removeClass('loading');
                }
            }
        });
    },
    updateHeaderV2() {
        const EXTRA_MARGINS_ON_TOP = 5;
        const header = $('#aff-header-sticky');
        const heroBanner = $('.aff-hero-v2');
        const isHeaderAfterHero = (heroBanner.outerHeight() + heroBanner.offset().top - EXTRA_MARGINS_ON_TOP) < $(window).scrollTop();

        if (isHeaderAfterHero) {
            header.removeClass('hide');
        } else {
            header.addClass('hide');
        }
    }
};
